// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "Snippet" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { SnippetStatus } from "./snippet-status.enum.gen";

export const SnippetGenShape = z.strictObject({
  description: z.string(),
  notes: z.string().optional(),
  keywords: z.string().optional(),
  parentId: z.string().optional(),
  data: z.string(),
  source: z.string().optional(),
  tags: z.array(z.string()),
  useCount: z.number(),
  rating: z.number(),
  contentOnly: z.boolean(),
  localisationHint: z.string().optional(),
  status: z.enum(SnippetStatus),
  publishedOn: z.string().nullable().optional(),
  publishedBy: z.string().nullable().optional(),
  lastPublishedOn: z.string().nullable().optional(),
  legacyId: z.string().nullable().optional(),
  libraryId: z.string(),
  created: z.string().optional(),
  createdUserId: z.string().optional(),
  lastEdited: z.string().optional(),
  lastEditedUserId: z.string().optional(),
  id: z.string(),
});
